import React from 'react'
import { useDispatch } from 'react-redux'
import { updateProductSetting, removeProduct } from '../reducers/product-settings'

const SelectProductsItem = ({item}) => {
  const elementId = 'dreamfox-product-field-'+item.id
  const dispatch = useDispatch()
  const handleDaysChanged = (e) => {
    const raw = e.target.value
    const days = raw === '' ? null : parseInt(raw, 10)
    dispatch(updateProductSetting({id: item.id, data: {days: isNaN(days) ? null : days}}))
  }
  const handleRemoveClick = () => {
    dispatch(removeProduct({id: item.id}))
  }
  return (
    <div className="dreamfox-select-products-item">
      <div className="dreamfox-select-products-item__name">
        <label htmlFor={elementId}>{item.name}</label>
      </div>
      <div>
        <input type="number" min="0" className="dreamfox-select-products-item__number" value={item.days == null ? '' : item.days} onChange={handleDaysChanged} />
      </div>
      <button type="button" className="dreamfox-select-products-item__remove" onClick={handleRemoveClick}>Remove</button>
    </div>
  )
}

export default SelectProductsItem
